export const ICON_SIZES = {
  tiny: 'Tiny',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
} as const;

export const ICON_SKINS = {
  standard: 'Standard',
  premium: 'Premium',
  light: 'Light',
  transparent: 'Transparent',
} as const;

export const ICON_PRIORITIES = {
  primary: 'Primary',
  secondary: 'Secondary',
} as const;
